import { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import Datetime from "react-datetime";

// @mui material components
import FormHelperText from "@mui/material/FormHelperText";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import MenuItem from "@mui/material/MenuItem";

// Material Dashboard 3 PRO React components
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";

import FormSelect from "components/DigiHapi/FormSelect";

import {
	SET_POST_TYPE_ERROR,
	SET_POST_TYPE,
	SET_POST_GOODDEAL,
	SET_POST_URL,
	SET_POST_URL_ERROR,
	CLEAR_POST_URL,
	SET_POST_GOODDEAL_ERROR,
	SET_POST_DATE,
	SET_POST_START_DATE_ERROR
} from "actions/types";
import { fetchGetOwnGoodDealsTitles } from "actions/gooddeal";

class Step1 extends Component {
	sendState() {
		return this.state;
	}

	componentDidMount() {
		this.props.fetchGetOwnGoodDealsTitles();
	}

	isValidated() {
		const {
			dispatch,
			eventType,
			urlState,
			isGoodDealType,
			goodDeal,
			isDateMandatory,
			startDate
		} = this.props;

		let success = true;
		if (!eventType) {
			dispatch({
				type: SET_POST_TYPE_ERROR
			});
			success = false;
		}
		if (urlState === "error") {
			dispatch({
				type: SET_POST_URL_ERROR
			});
			success = false;
		}
		if (isGoodDealType && !goodDeal) {
			dispatch({
				type: SET_POST_GOODDEAL_ERROR
			});
			success = false;
		}
		if (isDateMandatory && !startDate) {
			dispatch({
				type: SET_POST_START_DATE_ERROR
			});
			success = false;
		}
		return success;
	}

	render() {
		const {
			dispatch,
			eventTypes,
			eventType,
			typeErrorMsg,
			isGoodDealType,
			goodDeals,
			goodDeal,
			goodDealErrorMsg,
			urlState,
			url,
			urlErrorMsg,
			startDate,
			isDateMandatory,
			startDateErrorMsg
		} = this.props;
		return (
			<Grid container spacing={3} justifyContent="center">
				<Grid item xs={12}>
					<FormSelect
						label="Type *"
						value={eventType}
						placeholder="Sélectionner le type de publication"
						error={!!typeErrorMsg}
						helperText={typeErrorMsg}
						onChange={e =>
							dispatch({
								type: SET_POST_TYPE,
								payload: e.target.value
							})
						}
					>
						{eventTypes
							.filter(obj => obj.name !== "Annonce" || goodDeals.length > 0)
							.map(obj => (
								<MenuItem key={obj._id} value={obj}>
									{obj.name}
								</MenuItem>
							))}
					</FormSelect>
				</Grid>
				{isGoodDealType ? (
					<Grid item xs={12}>
						<FormSelect
							label="Annonce *"
							value={goodDeal}
							placeholder="Sélectionner l'annonce"
							error={!!goodDealErrorMsg}
							helperText={goodDealErrorMsg}
							onChange={e =>
								dispatch({
									type: SET_POST_GOODDEAL,
									payload: e.target.value
								})
							}
						>
							{(goodDeals || []).map(goodDeal => (
								<MenuItem key={goodDeal._id} value={goodDeal}>
									{goodDeal.title}
								</MenuItem>
							))}
						</FormSelect>
					</Grid>
				) : (
					<>
						<Grid item xs={12}>
							<MDInput
								label="Url de redirection"
								id="url"
								type="text"
								fullWidth
								success={urlState === "success"}
								error={urlState === "error"}
								helperText={urlErrorMsg}
								value={url || ""}
								onChange={e =>
									dispatch({
										type: SET_POST_URL,
										payload: e.target.value
									})
								}
								InputProps={{
									endAdornment:
										urlState === "error" ? (
											<InputAdornment position="end">
												<IconButton
													size="small"
													color="error"
													onClick={() =>
														dispatch({
															type: CLEAR_POST_URL
														})
													}
												>
													<Icon>close</Icon>
												</IconButton>
											</InputAdornment>
										) : undefined
								}}
							/>
						</Grid>
						<Grid item xs={12}>
							<MDTypography variant="button" fontWeight="medium">
								{"Date" + (isDateMandatory ? " *" : "")}
							</MDTypography>
							{/* Style the react-datetime input like the MD3 outlined inputs */}
							<MDBox
								mt={1}
								sx={{
									"& input": {
										width: "100%",
										border: "1px solid #d2d6da",
										borderRadius: "6px",
										padding: "10px 12px",
										fontSize: "0.875rem"
									}
								}}
							>
								<Datetime
									inputProps={{
										placeholder: "dd/MM/yyyy HH:mm"
									}}
									locale="fr_FR"
									value={startDate}
									onChange={value =>
										dispatch({
											type: SET_POST_DATE,
											payload: value
										})
									}
								/>
							</MDBox>
							{startDateErrorMsg && (
								<FormHelperText error>{startDateErrorMsg}</FormHelperText>
							)}
						</Grid>
					</>
				)}
			</Grid>
		);
	}
}

const mapStateToProps = state => {
	const {
		eventTypeId,
		goodDealsTitles,
		typeErrorMsg,
		isGoodDealType,
		goodDealId,
		goodDealErrorMsg,
		urlState,
		url,
		urlErrorMsg,
		startDate,
		isDateMandatory,
		startDateErrorMsg
	} = state.eventReducer;

	const { eventTypes } = state.entitiesReducer;
	return {
		eventTypes: Object.values(eventTypes),
		eventType: eventTypes[eventTypeId],
		goodDeals: Object.values(goodDealsTitles),
		typeErrorMsg,
		isGoodDealType,
		goodDeal: goodDealsTitles[goodDealId],
		goodDealErrorMsg,
		urlState,
		url,
		urlErrorMsg,
		startDate,
		isDateMandatory,
		startDateErrorMsg
	};
};

const mapDispatchToProps = dispatch => {
	let actions = bindActionCreators(
		{
			fetchGetOwnGoodDealsTitles
		},
		dispatch
	);
	return { ...actions, dispatch };
};
export default connect(mapStateToProps, mapDispatchToProps, null, {
	forwardRef: true
})(Step1);
